/**
 * @fileoverview PUT handler for the "/apps/multi_language_settings/update_locale/:locale_id" endpoint
 */
import fetch from "@lib/fetch";

import {
  createMutationFetcherFunctionWithShadowError,
  reactQueryMutationAdapter,
} from "../reactQueryFetcherAdapters";
import { appsMultiLanguageSettingsUpdateLocaleCacheKeys } from "./constants";
import type {
  AppsMultiLanguageSettingsUpdateLocaleProps,
  AppsMultiLanguageSettingsUpdateLocaleResult,
  UpdateLocaleErrors,
} from "./types";

export const putAppsMultiLanguageSettingsUpdateLocale = reactQueryMutationAdapter(
  appsMultiLanguageSettingsUpdateLocaleCacheKeys,
  createMutationFetcherFunctionWithShadowError<UpdateLocaleErrors>()(
    (props: AppsMultiLanguageSettingsUpdateLocaleProps): Promise<AppsMultiLanguageSettingsUpdateLocaleResult> => {
      return fetch(
        `/apps/multi_language_settings/update_locale/${props.localeId}`,
        "PUT",
        {
          a11y_lang: props.a11y_lang,
        },
        undefined,
        {
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
